const TEST_CONSTANTS = {
  test: 'test',
};

const THEME_COLOR = ''; // customize move to config/custom.js
const THEME_COLOR_SECOND = ''; // customize move to config/custom.js
const SITE_INFO = ''; // customize move to config/custom.js

export {TEST_CONSTANTS};
